import React from 'react';
import PortalPage from './PortalPage';

const PartnerPortal = () => <PortalPage audience="partner" />;

export default PartnerPortal;
